import { Text, Heading, Flex, Grid, Container, Box } from '@radix-ui/themes';
import { Image } from '@trashlab/sitesapp/src/organizations/junk-rescue/components/shared/image';
import Card from '@trashlab/sitesapp/src/organizations/junk-rescue/template/components/shared/card';
import FormFields from '@trashlab/sitesapp/src/organizations/junk-rescue/template/components/shared/form-fields';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/junk-rescue/lib/utils/get-variant-value';

export const RequestServiceForm = ({
  customTitle,
  customSubtitle,
  customDescription,
  withBackground = false,
  serviceTypeOverride,
}: {
  customTitle?: string;
  customSubtitle?: string;
  customDescription?: string;
  withBackground?: boolean;
  /** If provided, shows only this service type pre-selected in the form */
  serviceTypeOverride?: string;
}) => {
  const defaultTitle = useVariantValue('CONTACT_FORM_TITLE', 'Set up service');
  const defaultSubtitle = useVariantValue(
    'CONTACT_FORM_SUBTITLE',
    'Our simple online dumpster rental process',
  );
  const defaultDescription = useVariantValue(
    'CONTACT_FORM_DESCRIPTION',
    'Fill out the contact form and we will email or call you as soon as we can',
  );

  const title = customTitle ?? defaultTitle;
  const subtitle = customSubtitle ?? defaultSubtitle;
  const description = customDescription ?? defaultDescription;

  const contactUsImage = useVariantValue(
    'CONTACT_US_IMAGE',
    '/default/office-map.svg',
  );

  return (
    <Container
      size="4"
      p="8"
      className={
        withBackground
          ? `relative min-h-[200px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[url('/default/rental-steps-bg.svg')] before:bg-cover before:bg-center before:bg-no-repeat before:opacity-100 before:-z-10 after:content-[''] after:absolute after:inset-0 after:opacity-90 after:-z-10`
          : ''
      }
    >
      <Card>
        <Grid
          columns={{ initial: '1', sm: '2' }}
          gap="8"
          className="max-md:grid-cols-1"
        >
          <Flex gap="2" direction="column" className="h-fit max-w-[600px] p-4">
            <Text
              weight="bold"
              size="2"
              className="text-neutral-400"
              data-variable="CONTACT_FORM_SUBTITLE"
            >
              {subtitle}
            </Text>
            <Heading as="h2" size="8" weight="bold" data-variable="CONTACT_FORM_TITLE">
              {title}
            </Heading>
            <Text
              size="2"
              className="text-neutral-500"
              data-variable="CONTACT_FORM_DESCRIPTION"
            >
              {description}
            </Text>
            <Box className="h-fit mt-4">
              <FormFields serviceTypeOverride={serviceTypeOverride} />
            </Box>
          </Flex>

          <Box className="relative h-[300px] sm:h-[400px] md:h-[600px] lg:h-[700px] flex items-center justify-center p-4">
            <Image
              loading="lazy"
              src={contactUsImage}
              data-variable="CONTACT_US_IMAGE"
              className="rounded-xl object-cover w-full h-full shadow-lg"
              alt="Contact illustration"
            />
          </Box>
        </Grid>
      </Card>
    </Container>
  );
};
